// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mathematics"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M13.125 2H21V22H13.125V2Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M3 22.0004V4.22266L13.125 14.2227V22.0004H3Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 22.0004V4.22266L13.125 14.2227V18.1115V22.0004H3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17.8501 5.33301H21.0001M17.8501 8.66602H21.0001M17.8501 12H21.0001M17.8501 15.333H21.0001M17.8501 18.666H21.0001M13.125 2H21V22H13.125V2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MathematicsIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mathematics',
    ref,
    icon: element,
  },
));

MathematicsIcon.displayName = 'MathematicsIcon';

export default MathematicsIcon;
